import React from "react";

function MailingPauseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      fill="none"
      viewBox="0 0 23 24"
    >
      <path
        stroke="#C2790B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.5 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zM14 9v6M9 9v6"
      ></path>
    </svg>
  );
}

export default MailingPauseIcon;